(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cross-sell-modal"] && !Shopify.designMode) return;
  try {
    
  class CrossSellModal extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;

      this.items = this.querySelector('uwp-cart-items');
      this.cartContents = this.querySelector('.cross-sell-modal__purchase');
      this.content = this.querySelector('.cross-sell-modal__content');

      this.discountForms = this.querySelectorAll('.cross-sell-modal__giftcode-form');
      this.discountInputs = this.querySelectorAll('.cross-sell-modal__giftcode-form input');
      this.discountErrorCons = this.querySelectorAll('.cross-sell-modal__giftcode-errors');
      this.discountSuccesses = this.querySelectorAll('.cross-sell-modal__giftcode-success');
      this.discountErrorsGeneral = this.querySelectorAll('.cross-sell-modal__giftcode-general-error');
      this.discountErrorsShipping = this.querySelectorAll('.cross-sell-modal__giftcode-shipping-error');
      this.discountErrorsItemRequirements = this.querySelectorAll('.cross-sell-modal__item-requirements-missed');
      this.appliedDiscountCons = this.querySelectorAll('.cross-sell-modal__discounts');

      //Submit events
      this.addEventListener('submit', (event) => {
        const targetClasslist = event.target.classList;
        if (targetClasslist.contains('cross-sell-modal__card-form')) {
          event.preventDefault();
          event.stopPropagation();
          this.addItemToCart(event);
        } else if (targetClasslist.contains('cross-sell-modal__giftcode-form')) {
          event.preventDefault();
          event.stopPropagation();
          this.applyDiscount(event);
        }
      });

      //Click events
      this.addEventListener('click', (event) => {
        const targetClasslist = event.target.classList;
        if (
          targetClasslist.contains('cross-sell-modal__discount-input') ||
          event.target.closest('.cross-sell-modal__discount-input')
        ) {
          //Hide all error and success messages if the input is targeted
          this.hideDiscountCodeAlerts();
        } else if (
          targetClasslist.contains('cross-sell-modal__remove-discount') ||
          event.target.closest('.cross-sell-modal__remove-discount')
        ) {
          this.removeDiscount(event);
        }
      });

      document.addEventListener('click', this.closeModal);

      this.addEventListener('newItemForModal', function (event) {
        const addedLineItemId = event.detail.addedLineItemId;
        if (addedLineItemId) this.addedLineItemId = addedLineItemId;
        const updatedHtmlForModal = event.detail.html;
        if (updatedHtmlForModal) {
          this.rerenderCartItems(updatedHtmlForModal);
          this.rerenderRails(updatedHtmlForModal);
        }
      });

      if (this.dataset.c) {
        this.freeProductCodeArr = this.dataset.c
          .toUpperCase()
          .split(',')
          .map((code) => code.trim())
          .filter(Boolean);
      } else {
        this.freeProductCodeArr = [];
      }
      if (this.dataset.ac) {
        this.accessoryDiscountCodeArr = this.dataset.ac
          .toUpperCase()
          .split(',')
          .map((code) => code.trim())
          .filter(Boolean);
      } else {
        this.accessoryDiscountCodeArr = [];
      }
    }

    connectedCallback() {
      this.addEventListener('toggle', this.onDeliveryInfoToggle, true);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.closeModal);
    }

    onDeliveryInfoToggle = (event) => {
      const details = event.target;
      if (!details.matches('.cross-sell-modal__delivery-info') || !(details instanceof HTMLDetailsElement)) return;
      if (details.open) setTimeout(() => details.scrollIntoView({ behavior: 'smooth' }), 300);
    };

    rerenderRails(html) {
      const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
      const extraProducts = this.querySelector('.cross-sell-modal__extra-products');
      const newExtraProductsHtml = parsedHtml.querySelector('.cross-sell-modal__extra-products');
      if (!extraProducts || !newExtraProductsHtml) return;

      extraProducts.innerHTML = newExtraProductsHtml.innerHTML;

      if (this.flkty) this.flkty.destroy();

      const carousel = this.querySelector('.cross-sell-modal__carousel');
      const noOfCards = this.querySelectorAll('.cross-sell-modal__card').length;
      //If there is two cards or less to show, don't re-activate the carousel
      if (carousel && noOfCards && noOfCards > 2) {
        this.flkty = new Flickity(carousel, {
          // options
          cellAlign: 'left',
          contain: true,
          pageDots: false,
        });
        //Need to resize each time else the carousel doesn't set its height properly
        this.flkty.resize();
      }
    }

    rerenderCartItems = (html) => {
      const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
      const newItemsHtml = parsedHtml.querySelector('uwp-cart-items');
      if (!newItemsHtml) return;
      this.items.innerHTML = newItemsHtml.innerHTML;
      const newlyUpdatedItem = this.querySelector(`[data-line-item-id="${this.addedLineItemId}"]`);
      if (newlyUpdatedItem) newlyUpdatedItem.classList.add('cross-sell-modal__new-item');
    };

    closeModal = (e) => {
      var target = e.target;
      if (!target.closest) return;
      if (target.matches('[data-cross-sell-modal-close]')) {
        const modal = target.closest('.cross-sell-modal');
        if (!modal || modal !== this) return;
        if (modal) {
          modal.setAttribute('hidden', '');
          if (document.querySelector('body')) document.querySelector('body').style.overflow = '';
        }
      }
    };

    applyDiscount = async (event) => {
      event.preventDefault();
      event.stopPropagation();

      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const discountCode = form.querySelector('input[name="discount"]');
      if (!(discountCode instanceof HTMLInputElement) || typeof this.dataset.sectionId !== 'string') return;

      const discountCodeValue = discountCode.value.toUpperCase().trim();
      const existingDiscounts = this.getExistingDiscounts();
      if (!discountCodeValue || existingDiscounts.includes(discountCodeValue)) {
        discountCode.value = '';
        this.handleDiscountError('discount_code');
        return;
      }

      let applyingAccessoryDiscountCode = false;
      //If applying one of the accessory discount codes, notify Liquid using attributes as well (As accessory discount code might not be applicable yet)
      if (this.accessoryDiscountCodeArr.includes(discountCodeValue)) {
        const productRequirementStr = this.dataset.pr;
        const itemsArr = [...this.querySelectorAll('uwp-cart-item')];
        //If there are item quantity requirements for the discount code and they haven't been met, show an error message and don't apply the discount
        if (itemsArr && itemsArr.length > 0 && productRequirementStr && productRequirementStr.length > 0) {
          const productRequirementArr = productRequirementStr.split(',');
          const cartProductIdArr = itemsArr.map((item) => item.dataset.lineItemProductId);
          let cartMeetsRequirments = false;
          cartProductIdArr.forEach((productId) => {
            if (productId && productRequirementArr.includes(productId)) {
              cartMeetsRequirments = true;
              return;
            }
          });
          if (!cartMeetsRequirments) {
            this.handleDiscountError('item_requirements');
            return;
          }
        }
        applyingAccessoryDiscountCode = true;
      }

      try {
        form.classList.add('is-loading');

        this.hideDiscountCodeAlerts();

        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: { accessory_code: applyingAccessoryDiscountCode ? discountCodeValue : '' },
            discount: [...existingDiscounts, discountCodeValue].join(','),
            sections: this.sectionId,
          }),
        });

        const data = await response.json();

        const addedDiscountIsNotApplicable = data.discount_codes.find((discount) => {
          return discount.code === discountCodeValue && discount.applicable === false;
        });

        if (addedDiscountIsNotApplicable && !applyingAccessoryDiscountCode) {
          discountCode.value = '';
          this.handleDiscountError('discount_code');
          return;
        }

        if (typeof hj !== 'undefined' && hj) hj('event', 'cross-sell-modal_discount-code-applied');

        //Rerender modal UI
        if (data && data.sections && data.sections[this.sectionId]) {
          this.rerenderRails(data.sections[this.sectionId]);
          this.rerenderCartItems(data.sections[this.sectionId]);
        }

        const newHtml = data.sections[this.sectionId];
        const section = new DOMParser().parseFromString(newHtml, 'text/html');
        const discountCodes = section?.querySelectorAll('.cross-sell-modal__discount') || [];
        if (section) {
          const codes = Array.from(discountCodes)
            .map((element) => (element instanceof HTMLLIElement ? element.dataset.discountCode : null))
            .filter(Boolean);
          // Before updating applied discounts, we need to check if the shipping discount is applicable in the UI
          // we check the liquid logic compared to the cart payload to assess whether we leveraged
          // a valid shipping discount code.
          if (
            codes.length === existingDiscounts.length &&
            codes.every((code) => existingDiscounts.includes(code)) &&
            data.discount_codes.find((discount) => {
              return discount.code === discountCodeValue && discount.applicable === true;
            })
          ) {
            this.handleDiscountError('shipping');
            discountCode.value = '';
            return;
          }

          const newDiscountsHtml = section.querySelector('.cross-sell-modal__discounts');
          if (newDiscountsHtml) {
            this.appliedDiscountCons.forEach((con) => (con.innerHTML = newDiscountsHtml.innerHTML));
          }

          this.discountSuccesses.forEach((success) => (success.hidden = false));
        }
      } catch (error) {
        console.error(error);
      } finally {
        discountCode.value = '';
        form.classList.remove('is-loading');
      }
    };

    removeDiscount = async (event) => {
      event.preventDefault();
      event.stopPropagation();
      const closestDiscountCon = event.target.closest('.cross-sell-modal__discount');
      if (!closestDiscountCon) return;
      const discountCode = closestDiscountCon.dataset.discountCode;
      if (!discountCode) return;

      const activeDiscountArr = this.getExistingDiscounts().filter((code) => code !== discountCode);

      this.hideDiscountCodeAlerts();

      let removingFreeProductDiscountCode = false;

      const requestBody = {
        updates: {},
        discount: activeDiscountArr.join(),
        sections: this.sectionId,
      };

      ///If removing an accessory discount rather than a regular discount, make sure to remove the attribute as well
      if (
        closestDiscountCon.dataset.accessoryDiscountCode &&
        closestDiscountCon.dataset.accessoryDiscountCode == 'true'
      ) {
        requestBody.attributes = { accessory_code: '' };
      }

      //If one of the free product discount codes is being removed, remove any free products from the cart
      if (this.freeProductCodeArr.includes(discountCode.toUpperCase()) && this.dataset.v) {
        removingFreeProductDiscountCode = true;
        const possibleFreeVariantIdArr = this.dataset.v.split(',');
        possibleFreeVariantIdArr.forEach((variantId) => {
          if (!variantId) return;
          requestBody.updates[variantId] = 0;
        });
      }

      try {
        closestDiscountCon.classList.add('cross-sell-modal__discount--loading');

        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        });

        const data = await response.json();

        //Remove active discount element
        this.querySelectorAll(`.cross-sell-modal__discount[data-discount-code="${discountCode}"]`).forEach((discount) =>
          discount.remove()
        );

        if (typeof hj !== 'undefined' && hj) hj('event', 'cross-sell-modal_discount-code-removed');

        closestDiscountCon.focus();

        //Rerender modal UI
        if (data && data.sections && data.sections[this.sectionId]) {
          this.rerenderRails(data.sections[this.sectionId]);
          this.rerenderCartItems(data.sections[this.sectionId]);
        }
      } catch (error) {
        closestDiscountCon.classList.remove('cross-sell-modal__discount--loading');
        console.error(error);
      }
    };

    hideDiscountCodeAlerts() {
      if (this.discountErrorCons) this.discountErrorCons.forEach((con) => (con.hidden = true));
      const errorArr = [...this.querySelectorAll('.cross-sell-modal__giftcode-error')];
      if (errorArr && errorArr.length > 0) {
        errorArr.forEach((error) => {
          error.hidden = true;
        });
      }
      if (this.discountSuccesses) this.discountSuccesses.forEach((success) => (success.hidden = true));
    }

    getExistingDiscounts() {
      const firstDiscountsCon = this.querySelector('.cross-sell-modal__discounts');
      const discountCodes = [];

      //Return empty discount codes if the container can't be found
      if (!firstDiscountsCon) return discountCodes;

      const discountPills = firstDiscountsCon.querySelectorAll('.cross-sell-modal__discount');
      for (const pill of discountPills) {
        if (pill instanceof HTMLLIElement && typeof pill.dataset.discountCode === 'string') {
          discountCodes.push(pill.dataset.discountCode);
        }
      }
      return discountCodes;
    }

    handleDiscountError(type) {
      const target =
        type === 'discount_code'
          ? this.discountErrorsGeneral
          : type === 'shipping'
          ? this.discountErrorsShipping
          : this.discountErrorsItemRequirements;
      this.discountErrorCons.forEach((con) => (con.hidden = false));
      target.forEach((error) => (error.hidden = false));
    }

    addItemToCart = async (event) => {
      this.hideDiscountCodeAlerts();

      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      // Only have to worry about a single variant selector as the Liquid is set up not to render products with more than one variant option
      const variantSelector = form.querySelector('select');

      const card = form.closest('.cross-sell-modal__card');
      if (!card) return;

      if (variantSelector && !variantSelector.value) {
        console.error('No variant selected');
        const errorAlert = card.querySelector('.cross-sell-modal__card-error');
        if (errorAlert) errorAlert.hidden = false;
        //Need to resize carousel so the error is visible
        if (this.flkty) this.flkty.resize();
        return;
      }

      try {
        const formData = new FormData(form);

        form.classList.add('is-loading');
        formData.append('sections', this.sectionId);

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          body: formData,
        });

        // Minimum delay so the request isn't too fast, causing confusing layout shift
        const minimumFetchDuration = 300;

        const [fetchResult] = await Promise.all([
          response,
          new Promise((resolve) => setTimeout(resolve, minimumFetchDuration)),
        ]);

        if (!fetchResult.ok) {
          throw new Error('Something went wrong');
        }

        const data = await fetchResult.json();

        if (typeof hj !== 'undefined' && hj) hj('event', 'cross-sell-modal_item-added-to-cart');

        //Refresh cart to add free product to it
        if (data && data.sections && data.sections[this.sectionId]) {
          this.rerenderCartItems(data.sections[this.sectionId]);
          this.rerenderRails(data.sections[this.sectionId]);
        }

        if (this.cartContents) this.cartContents.scrollIntoView({ behavior: 'smooth' });
      } catch (error) {
        console.error(error);
      } finally {
        form.classList.remove('is-loading');
      }
    };

    hideFreeProductError(event) {
      const input = event.target;
      const freeProduct = input.closest('.cross-sell-modal__free-product');
      if (!freeProduct) return;
      const errorAlert = freeProduct.querySelector('.cross-sell-modal__free-product-error');
      if (errorAlert) errorAlert.hidden = true;
    }
  }

  if (!customElements.get('cross-sell-modal')) {
    customElements.define('cross-sell-modal', CrossSellModal);
  }

  } catch(e) { console.error(e); }
})();
})();
